module.exports = __webpack_public_path__ + "static/media/notify.6db5b63d.wav";